/**
 * 미션 화면 ① — 인트로 영상. **OX 퀴즈·사진찍기 공용**
 * (Figma `3229:42024` / `3379:44332` — 두 노드의 배경·오버레이·영상 자리가 동일하다.)
 *
 * 사용자 요청 원문
 *   OX:      *"QR을 찍으면 이 피그마 화면이 나오고 해당 OX퀴즈의 인트로 영상이 가운데 나와야한다"*
 *   사진찍기: *"이 피그마 링크 배경에 Z부분 대신 CRM서비스에서 사진촬영 미션 생성할 때
 *             저장한 주렁로고 동영상이 나온 후"*
 *
 * 🔴 그래서 이름에 미션명이 없다. 읽어주는 문구만 `ariaLabel` 로 갈아끼운다 —
 *    사진찍기에서 "OX 퀴즈 시작 영상" 이라고 읽으면 그 자체가 결함이다.
 *
 * 구성: CRM이 내려준 공통 인트로 영상을 전체 화면으로 재생한다.
 * 재생 전에는 단색 배경과 투명 video로 Android WebView의 네이티브 재생 버튼 노출을 막는다.
 * 별도 번들 이미지 fallback은 사용하지 않는다.
 *
 * 워치독은 `useQuestVideoWatchdog` 이 소유한다 — 로딩 10초·무진행 5틱 후 **반드시**
 * `onFinished` 로 빠져나간다. 아이를 정지 화면에 가두지 않는 것이 이 화면의 안전 계약이다.
 *
 * 회귀 가드: OxQuizFlowScreens.test.jsx · FunnyPhotoFlowScreens.test.jsx
 */
import React from 'react';
import useQuestVideoWatchdog from '../../hooks/useQuestVideoWatchdog';
import './OxQuizFlow.css';

export default function MissionIntroVideoScreen({
  videoUrl, onFinished, onAbort, ariaLabel = '미션 시작 영상', logLabel = '미션 인트로 영상',
}) {
  const { videoRef, videoPlaying, isVideoPhase, videoHandlers } = useQuestVideoWatchdog({
    active: true,
    videoUrl,
    onFinished,
    onAbort,
    logLabel,
  });

  // URL 이 없으면 훅이 즉시 onFinished 를 부른다(부모가 이 화면을 건너뛰도록 라우팅하지만
  // 이중 방어). 그 한 프레임 동안 빈 무대가 보이지 않게 아무것도 그리지 않는다.
  if (!isVideoPhase) return null;

  return (
    <div className="oxq-screen oxq-intro" data-testid="mission-intro-screen">
      <div className="oxq-intro-stage">
        <video
          ref={videoRef}
          className={`oxq-intro-video${videoPlaying ? ' oxq-intro-video-playing' : ''}`}
          src={videoUrl}
          autoPlay
          playsInline
          preload="auto"
          aria-label={ariaLabel}
          data-testid="mission-intro-video"
          {...videoHandlers}
        />
      </div>
    </div>
  );
}
